<template>
    <BreadCrumb PageTitle="Ajouter un emploi du temps" />
    <AddEmploi />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import AddEmploi from "@/components/EmploiDuTemps/AddEmploi.vue";
  
    export default defineComponent({
      name: "AddEmploiPage",
      components: {
        BreadCrumb,
        AddEmploi,
      },
    });
  </script>